var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload-container" }, [
    _c("div", [
      _c("button", { class: _vm.buttonClass, on: { click: _vm.chooseFile } }, [
        _c("i", { class: _vm.icon }),
        _vm._v("  Choose file\n        ")
      ]),
      _vm._v(" "),
      _c("input", {
        ref: "upload",
        attrs: { type: "file", accept: _vm.accept, hidden: "" },
        on: { change: _vm.getFile }
      })
    ]),
    _vm._v(" "),
    _c("span", { staticClass: "file-name" }, [_vm._v(_vm._s(_vm.fileName))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }